import { set } from 'lodash';
import React, { useState, useEffect } from 'react';
import * as qf from '../misc/qf';

const MuteBtn = ({ media, el }) => {
  const [showMuteBtn, setShowMuteBtn] = useState(false);
  const [muted, setMuted] = useState(false);
  const [contextLinks, setContextLinks] = useState(undefined);

  const getContextLinks = () => {
    return qf.getJSON(media._links.context_actions.href)
      .then( res => {
        if (res._links.mute) {
          setMuted(false);
        } else {
          setMuted(true);
        }
        setContextLinks(res)
      })
      .catch( err => console.error(err));
  }

  const mute = () => {
    if (muted) {
      qf.post(contextLinks._links.unmute.href)
        .then( async res => {
          await getContextLinks();
        })
        .catch( err => console.error(err) );
    } else {
      qf.post(contextLinks._links.mute.href)
        .then( async res => {
          await getContextLinks();
        })
        .catch( err => console.error(err) );
    }
  };

  useEffect( () => {
    qf.getJSON(media._links.context_actions.href)
      .then( res => {
        if (res._links.mute || res._links.unmute) {
          setContextLinks(res);
          if (res._links.mute) {
            setMuted(false);
          } else {
            setMuted(true);
          }
          setShowMuteBtn(true);
        } else {
          el.remove();
        }
      })
      .catch( err => console.error(err));
  }, [])

  if (!showMuteBtn) {
    return (<></>)
  };

  return (
    <a onClick={mute}>
      { muted ? (<><i className="fa-solid fa-volume-high"></i> Unmute</>) : (<><i className="fa-solid fa-volume-off"></i> Mute</>) }
    </a>
  )
}

export default MuteBtn;
